// extracted by mini-css-extract-plugin
module.exports =  {"tc-resource-picker-sort-options":"SortOptions-module__tc-resource-picker-sort-options___rlPAg","option-label":"SortOptions-module__option-label___OrU9g"};